

/**
 * This function takes in a number and returns the letter associated with that number.
 * For example, 0 returns A, 1 returns B, 2 returns C, etc. Once the number reaches 26, it
 * will start adding a second letter. For example, 26 returns AA, 27 returns AB, 28 returns AC, etc.
 * @param {*} num 
 */
export function getRowLetterFromNumber(num) {
  let letter = "";
  while (num >= 0) {
    letter = String.fromCharCode(65 + (num % 26)) + letter;
    num = Math.floor(num / 26) - 1;
  }
  return letter;
}

export const parseSeatMapTo2DArray = (seatMap) => {
  let newSeatMap = [];

  seatMap.forEach((seat) => {
    let row = seat.r - 1;
    let col = seat.c - 1;

    if (!newSeatMap[row]) {
      newSeatMap[row] = [];
    }

    newSeatMap[row][col] = seat;
  });

  return newSeatMap;
}